module.exports = __webpack_public_path__ + "img/example.e3a41c82.png";